/* tslint:disable */

/**
 */
export class TicketDestroyView {
    shift_id?: number;
    ticket_number?: string;
    amount?: number;
    type?: string;
    printed_at?: string;
    description?: string;
    image?: string;
    fullname?: string;
    sub_fullname?: string;
}
